module.exports = "<p>\r\n  video-help works!\r\n</p>\r\n"